// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"9e1c732a","455":"2c152d8f","977":"1a647242"}[chunkId] + ".chunk.js";
};